/**
 * 变更类型
 */
export enum ChangeTypeEnum {
  /** 新增*/
  Add = 'Add',
  /** 修改*/
  Update = 'Update',
  /** 删除*/
  Delete = 'Delete',
  /** 覆盖*/
  Overwrite = 'Overwrite',
  /** 重复*/
  Duplicate = 'Duplicate',
  /** 聚合*/
  Aggregation = 'Aggregation',
}
/**
 * 审批流程状态
 */
export enum FlowStatusEnum {
  /** 草稿*/
  Draft = 'Draft',
  /** 待审批*/
  WaitAudit = 'WaitAudit',
  /** 已生效*/
  Finish = 'Finish',
  /** 已退回*/
  Return = 'Return',
  /** 已拒绝*/
  Reject = 'Reject',
}

/** Module List数据来源 */
export enum ModuleListDataSourceEnum {
  /** Module List维护*/
  ModuleList = 'ModuleList',
  /** 导入*/
  Import = 'Import',
  /** 从订单信息界面跳转创建*/
  Order = 'Order',
}

/** 物料主数据来源 */
export enum MaterialDataSourceEnum {
    /** SAP同步 */
    Sap = 'Sap',
    /** Module List维护 */
    ModuleList= 'ModuleList',
} 

/** 批量操作类型 */
export enum BatchActionEnum {
  /** 删除 */
  Delete = 'delete',
  /** 提交 */
  Submit = 'submit',
  /** 撤回 */
  Withdraw = 'withdraw',
  /** 更改审批人 */
  ChangeApprover = 'changeApprover',
  None = 'none',
}
